import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class DocumentTypeService {

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/document/';

  getAllDocumentType() {
    return this.http.get<any>(this.baseUrl + 'getDocumentTypes/');
  }

}
